const CONV_ARCHIVE = {
  FILTER_TYPE_LABEL: 'Filter on',
  EXCEL_EXPORT_LABEL: 'Excel export',
  OPERATOR_SELECT_LABEL: 'Select operator',
  DATE_FROM_LABEL: 'From',
  DATE_TO_LABEL: 'To',

  EMAIL_FILTER_LABEL: 'Email',
  NAME_FILTER_LABEL: 'Username',
  TEXT_FILTER_LABEL: 'message text',

  FILTER_TYPE_DATE_CREATED_AT: 'Conversation creation date',
  FILTER_TYPE_DATE_UPDATED_AT: 'Last message date',
  FILTER_TYPE_EMAIL_AND_UPDATE: 'Email and last message date',
  FILTER_TYPE_EMAIL_AND_CREATEDAT: 'Email and user creation date',
  FILTER_TYPE_OPEN_CONVS: 'Open conversations',
  FILTER_TYPE_EMAIL: 'Email',

  NAME_FILED_PLACEHOLDER: 'Username',

  FILTER_TYPE_DATE_AND_TEXT: 'Date and text',
  FILTER_TYPE_USER_CREATION_DATE: 'User creation date',
  FILTER_TYPE_USER_NAME: 'User name',

  FILTER_SUBMIT_BTN_LABEL: 'Apply',
  CONV_LIST_TITLE: 'Conversations list',
  NO_CONV_FOUND_MSG: 'No conversation found',
  CONVS_TITLE: 'Conversations',

  CONVS_TABLE_HEAD_1: 'Name',
  CONVS_TABLE_HEAD_2: 'First visit',
  CONVS_TABLE_HEAD_3: 'Last visit',
  CONVS_TABLE_HEAD_4: 'Conversations',
  CONVS_TABLE_HEAD_5: 'Email',
  CONVS_TABLE_HEAD_6: 'City',

  CONV_DETAIL_LAST_PAGE: 'Last page',
  CONV_DETAIL_IP: 'IP',
  CONV_DETAIL_BROWSER: 'Browser',
  CONV_DETAIL_BROWSER_VERSION: 'Browser version',
  CONV_DETAIL_MOBILE_USER: 'Mobile user',
  CONV_DETAIL_OS: 'OS',
  CONV_DETAIL_REFERRER: 'Referrer',

  OPEN_CONV_BTN_LABEL: 'Open conversation',
  ABOUT_USER: 'About User',

  USER_INFO_INPUT_PLACEHOLDER: 'Write and hit enter',
  USER_INFO_INPUT_DETAILS_TITLE: 'Notes',

  CONV_CARD_IN_WEBSITE_TEXT: 'Website',
  CONV_COUNT_NUM_LABEL: 'Conversation',

  CHAT_EXPORT: 'Chat export',

  ENTER_TIME_RANGE: 'Enter time range',
  IMAGE_PREVIEW_LABEL: 'Image',

  BTN_DISABLED_TOOLTIP:
    'To use this package you need to purchase Premium package',

  NOTE_PLACEHOLDER: 'Type something and press ENTER',

  NOTE_SUBMIT_TOOLTIP: 'Submit',
  NOTE_DISCARD_TOOLTIP: 'Discard',
  NOTE_EDIT_TOOLTIP: 'Edit',

  VOICE_MESSAGE: 'Voice Message',
  VIDEO_MESSAGE: 'Video Message',
  FILE_MESSAGE: 'File Message',
  IMAGE_MESSAGE: 'Image Message',

  EDITED_MESSAGE_BADGE: 'Edited',

  // user visits archive
  USER_VISITS_FILTER_1: 'Phone Number',
  USER_VISITS_FILTER_2: 'Email',
  USER_VISITS_FILTER_3: 'Had Conversation',
  USER_VISITS_FILTER_TITLE: 'Users Archive',
  USER_VISITS_LIST_TITLE: 'Users Archive List',
  USER_VISITS_COUNT_NUM_LABEL: 'User',
  USER_VISITS_LIST_EMPTY: 'No items found!',
  USER_VISITS_TABLE_HEAD_1: 'Name',
  USER_VISITS_TABLE_HEAD_2: 'Creation Date',
  USER_VISITS_TABLE_HEAD_3: 'Conversation',
  USER_VISITS_TABLE_HEAD_4: 'Status',
  USER_VISITS_TABLE_HEAD_5: 'Email',
  USER_VISITS_TABLE_HEAD_6: 'Phone Number',
  USER_VISIT_STATUS_TABLE_ITEM_ONLINE: 'Online',
  USER_VISIT_STATUS_TABLE_ITEM_OFFLINE: 'Offline',
  USER_VISITS_CONV_TABLE_ITEM_YES: 'Yes',
  USER_VISITS_CONV_TABLE_ITEM_NO: 'No',
  USER_VISITS_IN_VALID_EMAIL: 'Invalid email!',
  USER_VISITS_IN_VALID_PHONE: 'Invalid phone number!',
  USER_VISITS_DATE_FROM_LABEL: 'Date',
};

export default CONV_ARCHIVE;
